import api from './api';

const adminUserService = {
  // Fetch admin users list
  getAdminUsers: async () => {
    const response = await api.get('/admin-users');
    return response.data;
  },

  // Create new admin user
  createAdminUser: async (data) => {
    const response = await api.post('/admin-users', data);
    return response.data;
  },

  // Reset admin user password
  resetPassword: async (id, password) => {
    const response = await api.post(`/admin-users/${id}/reset-password`, { password });
    return response.data;
  },

  // Delete admin user
  deleteAdminUser: async (id) => {
    const response = await api.delete(`/admin-users/${id}`);
    return response.data;
  }
};

export default adminUserService;
